import { render } from "./AlertsView.vue?vue&type=template&id=0a9049cc&ts=true"
import script from "./AlertsView.vue?vue&type=script&lang=ts"
export * from "./AlertsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__